import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        user: false
    },
    mutations: {
        // 登录
    login(state, userInfo) {
            state.user = userInfo;
            if (userInfo) {
                localStorage.setItem(
                    "userInfo",
                    typeof userInfo === "string"
                        ? userInfo
                        : JSON.stringify(userInfo)
                );
            }
        },
        logout(state) {
            state.user = null;
            localStorage.removeItem("userInfo");
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js